import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/free-solid-svg-icons";
import { PromotionFeedbackInvalidCloseIcon } from "components/Images/PromotionFeedbackInvalidCloseIcon";
import { PromotionFeedbackValidCloseIcon } from "components/Images/PromotionFeedbackValidCloseIcon";

export const InvalidPromotionFeedback = ({
  setPromoString,
  calculateCart,
  promoName,
  promoMessage
}) => {
  if (promoName === "") {
    return null;
  }

  return (
    <tr
      role="row"
      className="invalidPromotionFeedback"
      id="invalidPromotionFeedback"
    >
      <td
        role="cell"
        className="invalidPromoCode--name"
        id="invalidPromoFeedbackText"
        width="100%"
      >
        <span>{promoName}</span> - {promoMessage}
      </td>
      <td
        role="cell"
        className="invalidPromoCode--remove"
        id="invalidPromoFeedbackRemoveButtonContainer"
      >
        <button
          className="promotionFeedbackButton"
          id="promotionFeedbackRemoveButton"
          type="button"
          onClick={() => {
            setPromoString("");
            calculateCart({ promosToApply: [] });
            sessionStorage.removeItem("promotions");
          }}
          aria-label="Close Alert"
        >
          <PromotionFeedbackInvalidCloseIcon />
        </button>
      </td>
    </tr>
  );
};

InvalidPromotionFeedback.propTypes = {
  promoName: PropTypes.string,
  promoMessage: PropTypes.string,
  setPromoString: PropTypes.func,
  calculateCart: PropTypes.func
};

InvalidPromotionFeedback.defaultProps = {
  promoName: undefined,
  promoMessage: "Please check the spelling, expiration date or excluded items.",
  setPromoString: undefined,
  calculateCart: undefined
};

export const ValidPromotionFeedback = ({
  setPromoString,
  calculateCart,
  cart
}) => {
  if (cart.appliedPromo.length === 0) {
    return null;
  }

  return (
    <tr
      role="row"
      className="promotionFeedback__container"
      id="validPromotionFeedback"
    >
      <td
        role="cell"
        className="validPromoCode--name"
        id="validPromoFeedbackText"
      >
        <div
          className="validPromoCode--priceTag"
          id="validPromoFeedbackPriceTagContainer"
        >
          <FontAwesomeIcon
            icon={faTag}
            className="me-2"
            id="validPromoFeedbackPriceTag"
          />
        </div>
        <span>{cart.appliedPromo}</span>
      </td>
      <td
        role="cell"
        className="validPromoCode--remove"
        id="validPromoFeedbackRemoveButtonContainer"
      >
        <button
          className="promotionFeedbackButton"
          id="promotionFeedbackRemoveButton"
          type="button"
          onClick={() => {
            setPromoString("");
            calculateCart({ promosToApply: [] });
            sessionStorage.removeItem("promotions");
          }}
          aria-label="Remove Promotion"
        >
          <PromotionFeedbackValidCloseIcon />
        </button>
      </td>
    </tr>
  );
};

ValidPromotionFeedback.propTypes = {
  setPromoString: PropTypes.func,
  calculateCart: PropTypes.func,
  cart: PropTypes.shape({
    appliedPromo: PropTypes.array
  })
};

ValidPromotionFeedback.defaultProps = {
  setPromoString: undefined,
  calculateCart: undefined,
  cart: undefined
};
